<template>
    <div>
        <div class='maps-container' >
            <template v-for='store in nearest_stores' :key='store.id' >
                <StoreDetails :store='store' @selectedStoreListener='selectedStore'/>
            </template>
        </div>
    </div>
</template>

<script>
import Field from '@/ecom/components/fields/Field.vue';
import Button from '@/ecom/components/buttons/Button.vue';
import StoreDetails from '@/ecom/components/store_lookup/StoreDetails.vue';
import LocalStoreLookup from '@/ecom/components/store_lookup/LocalStoreLookup.vue';
import DeliveryStoreLookup from '@/ecom/components/store_lookup/DeliveryStoreLookup.vue';
import {checkAuth, closeModal} from "@/global/modules/functions.js";

export default {
    components: {Field, Button, StoreDetails, LocalStoreLookup, DeliveryStoreLookup},
    emits: ['selectedStoreListener', 'errorListener'],
    props:['selected_local_store', 'postcode', 'postcode_watcher'],
    data(){
        return{
            errors:{},
            nearest_stores: []
        }
    },
    methods:{
        async getNearestStores(){
            //this.postcode = postcode;
            let response = await fetch(`/api/store-locator/nearest-stores?postcode=${this.postcode}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.errors = {};

                if(results.errors.length != 0){
                    this.errors = results.errors;
                    this.$emit('errorListener', this.errors);
                }
                else{
                    this.nearest_stores = results.nearest_stores
                }
            }
        },
        async selectedStore(selected_store){      
            this.nearest_stores = [];
            this.$emit('selectedStoreListener', selected_store);  
        }
    },
    watch: {
        'postcode_watcher': function() {
            this.getNearestStores();
        }
    }
}
</script>

<style lang="scss" scoped>
.maps-container{
    margin-top: 40px;
    display: flex;
    justify-content: space-evenly;
    gap: 40px;
    flex-wrap: wrap;
}
</style>